import React from 'react'

export interface ITargetContext {
  citrixId: string
  email: string
  isCommonUser?: boolean
  defaultTarget: string
  regionIdentifier?: string
  adfsUserInfo?: any
  additionalTargets?: any
  contractCountry?: string
  isInfluencer?: boolean
}

const defaultTargetContext: ITargetContext = {
  citrixId: '',
  email: '',
  isCommonUser: false,
  defaultTarget: '',
  regionIdentifier: '',
  adfsUserInfo: undefined,
  additionalTargets: undefined,
  contractCountry: '',
  isInfluencer: false,
}

export const TargetContext =
  React.createContext<ITargetContext>(defaultTargetContext)

export const useTargetContext = () => React.useContext(TargetContext)
